import * as React from "react";
import { Box, Button, IconButton, Typography } from "@mui/material";
import Modal from "@mui/material/Modal";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import { useSelector } from "react-redux";
import { RootState } from "@store/store";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  maxWidth: "100%",
  borderRadius: ".75rem",
  bgcolor: "background.paper",
  boxShadow: 2,
  display: "flex",
  flexDirection: "column",
  maxHeight: "400px",
  height: "auto",
  overflowY: "auto",
};

type DisclaimerROWModalProps = {
  open: boolean;
  handleClose: () => void;
  onSubmit: () => void;
};

const DisclaimerROWModal: React.FC<DisclaimerROWModalProps> = ({
  open,
  handleClose,
  onSubmit,
}) => {
  const { profile, loading, error } = useSelector(
    (state: RootState) => state.profile,
  );

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="undertaking-modal-title"
      aria-describedby="undertaking-modal-description"
      disableAutoFocus
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.3)",
          },
        },
      }}
    >
      <Box sx={style}>
        <div className="flex justify-between items-center mb-4 pb-2 modal-header py-3 px-8">
          <h3 id="undertaking-modal-title" className="font-bold body-l">
            Further Instructions
          </h3>
          <IconButton
            sx={{
              background: "#FFFFFF",
              padding: "6px 8px",
              borderRadius: "2px",
              "&:hover": {
                backgroundColor: "#E7E4F8",
              },
            }}
            onClick={handleClose}
          >
            <ClearOutlinedIcon className="download-icon" />
          </IconButton>
        </div>

        <div
          className="modal-content py-3 px-8"
          style={{
            // background: "#F8F8FC",
            borderRadius: 12,
            paddingLeft: 24,
            margin: 0,
            fontSize: 12,
            height: "fit-content",
            // height: 300
          }}
        >
          <Typography
            variant="subtitle1"
            fontWeight={700}
            gutterBottom
            sx={{ color: "#3A1C73" }}
          >
            Please read the following instructions carefully:
          </Typography>
          <ul style={{ paddingLeft: 24, margin: 0, fontSize: 12, height: 150 }}>
            <li>
              <Typography variant="body1" sx={{ mb: 1.5 }}>
                The Applicant hereby acknowledges and agrees that the submission
                of a duly completed application form along with the prescribed
                one-time application fee. The Applicant affirms that all
                information provided at the time of submission is true,
                complete, and accurate.
              </Typography>
            </li>
            <li>
              <Typography variant="body1" sx={{ mb: 1.5 }}>
                The Applicant agrees that the decision of the Competent
                Authority on all matters related to the application shall be
                final and in accordance with the provisions of The Control of
                National Highways (Land and Traffic) Act, 2002. The Competent
                Authority reserves the right to request additional information
                or verification at any stage without liability for delays or
                refusals due to incomplete or inaccurate submissions.
              </Typography>
            </li>

            <li>
              <Typography variant="body1">
                Any misrepresentation, omission or suppression of facts or
                disclosure of incorrect information detected at any stage, shall
                lead to withdrawal of the approvals, along with applicable
                penalties and costs.
              </Typography>
            </li>
          </ul>
        </div>
        <div className="modal-footer flex justify-end p-4">
          <Button
            variant="contained"
            className="stepper-next-btn"
            style={{ width: "fit-content" }}
            onClick={onSubmit}
          >
            I Agree
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default DisclaimerROWModal;
